//export type AttendanceStatus = "attend" | "not attend" | "waiting list";

export enum AttendanceStatus {
    attend = 922520000,
    notAttend = 922520001,
    waitingList = 922520002
}

export interface Course {
    courseId: string;
    businessAreaId: string;
    name: string;
    createdon: string;
    statecode: number;
    statuscode: number;
    registrationWindowStart: string;
    registrationWindowEnd: string;
    overriddenCreatedon: string;
    publishedWeb: boolean;
    maxParticipants: number;
    minimumParticipants: number;
    courseFrom: string;
    courseTo: string;
    //courseDuration: number;
    coursePrice: number;
    courseDate: string;
    decription: string;
    seatsOccupied: number;
    seatsLeft: number;
    courseAddress: string;
    currency: string;
    courseInstructor: string;
}

export interface FilteredCourse extends Course {
    isFiltered?: boolean;
}

export interface CoursesDTO {
    "@odata.context": string;
    value: CourseDTO[];
}

export interface CourseDTO {
    "@odata.etag": string;
    svk_coursesid: string;
    _svk_businessarea_value: string;
    svk_name: string;
    createdon: string;
    statecode: number;
    statuscode: number;
    svk_registrationwindowstart: string;
    svk_registrationwindowend: string;
    overriddencreatedon: string;
    svk_publishonweb: boolean;
    svk_maximumnumberofparticipants: number;
    svk_minimumnnumberofparticipants: number;
    svk_timeto: string;
    svk_courseprice: number;
    svk_timefrom: string;
    svk_decription: string;
    svk_numberofseatstaken: number;
    svk_numberofseatsleft: number;
    svk_placeofcourse: string;
    _transactioncurrencyid_value: string;
    svk_courseinstructor: string;
}

export interface CourseRegistration {
    ["svk_Contact@odata.bind"]: string;
    ["svk_CourseName@odata.bind"]: string;
    svk_attendingcourse: AttendanceStatus;
    svk_coruseattenderid: string;
    svk_customerreference: string;
    svk_allowshowonweb: boolean;
    svk_remark: string;
}

export interface CourseCompanyContact {
    contactName: string;
    contactId: string;
    courseAntenderId: string;
    attendingcourse: AttendanceStatus;
    remarks?: string;
}
export interface CourseAttender {
    name: string;
    contactId: string;
    businessUnit: string;
    courseAntenderId: string;
    attendingcourse: AttendanceStatus;
    showOnWeb: boolean;
    remarks?: string;
}

export interface CourseAttenderDTO {
    "@odata.etag": string;
    createdon: string;
    exchangerate: number;
    importsequencenumber: number | null;
    modifiedon: string;
    overriddencreatedon: string | null;
    statecode: number;
    statuscode: number;
    svk_allowshowonweb: boolean | null;
    svk_attendingcourse: number;
    svk_coruseattenderid: string;
    svk_courseprice: number;
    svk_courseprice_base: number;
    svk_invoicetext: string | null;
    svk_name: string;
    svk_customerreference: string | null;
    svk_remark: string | null;
    timezoneruleversionnumber: number | null;
    utcconversiontimezonecode: number | null;
    versionnumber: number;
    _createdby_value: string;
    _createdonbehalfby_value: string | null;
    _modifiedby_value: string;
    _modifiedonbehalfby_value: string | null;
    _ownerid_value: string;
    _owningbusinessunit_value: string;
    _owningteam_value: string | null;
    _owninguser_value: string;
    _svk_addedby_value: string | null;
    _svk_attendercompany_value: string;
    _svk_contact_value: string;
    _svk_coursename_value: string;
    _svk_invoiceproduct_value: string;
    _svk_salesorder_value: string | null;
    _transactioncurrencyid_value: string;
}
export interface CourseAttendersDTO {
    "@odata.context": string;
    value: CourseAttenderDTO[];
}

export interface CourseAttenderAccount {
    "@odata.context": string;
    "@odata.etag": string;
    accountid: string;
    name: string;
}
export interface CourseAttenderContact {
    "@odata.context": string;
    "@odata.etag": string;
    contactid: string;
    fullname: string;
}
